
import { useState, useEffect } from 'react';
import { getCurrentSubscription, Subscription } from '@/services/subscriptionService';

export const useSubscription = (userId: string | undefined) => {
  const [subscription, setSubscription] = useState<Subscription | null>(null);

  useEffect(() => {
    if (userId) {
      fetchSubscription();
    }
  }, [userId]);

  const fetchSubscription = async () => {
    try {
      const subscriptionData = await getCurrentSubscription();
      setSubscription(subscriptionData);
      
      if (subscriptionData) {
        localStorage.setItem('subscription', JSON.stringify({
          tier: subscriptionData.tier,
          status: subscriptionData.status
        }));
        
        // Dispatch custom event to notify other components
        window.dispatchEvent(new Event('subscriptionUpdated'));
      }
    } catch (error) {
      console.error('Error fetching subscription:', error);
    }
  };

  return { subscription };
};
